import { getContext, setContext } from 'svelte';
import { writable, type Writable } from 'svelte/store';

export type Dialog = 'forgot-password' | 'signin' | 'signup' | null;

export function initDialog() {
  if (!getContext<Writable<Dialog>>('dialog')) {
    setContext('dialog', writable(null));
  }
}

export function getDialog() {
  return getContext<Writable<Dialog>>('dialog');
}
